import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../model/User';
import { HistoryService } from '../../service/history.service';
import { HistoryEntry } from '../../model/HistoryEntry';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrl: './left-menu.component.scss'
})
export class LeftMenuComponent {

  public user: User = new User();

  constructor(
    private _historyService: HistoryService,
    private router: Router
  ) {}

  recentHistory(): HistoryEntry[] {
    return this._historyService.list();
  }

  goToHistoryEntry(id: string) {
    this.router.navigate(['/'], { queryParams: { restoreFrom: id } });
  }

  goToWelcome() {
    this.router.navigate(['/'], { queryParams: { step: 1 } });
  }

  clearHistory() {
    this._historyService.clear();
  }
}
